'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$0024158 from "./presto.types$$anon$158.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dSeed$002dPayload$0024 from "./presto.types$-Two-Factor-Auth-Seed-Payload$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthPayload$$anon$157() {
  this.ccJ = null;
  this.ccB = null;
  this.ccC = false;
  this.ccK = null;
  this.ccL = false;
  this.ccO = null;
  this.ccH = null;
  this.ccI = false;
  this.ccD = null;
  this.ccE = false;
  this.ccF = null;
  this.ccG = false;
  this.ccM = false;
  this.ccN = false;
  this.ccJ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.ccO = "TwoFactorAuthSeedPayload";
}
export { $c_Lpresto_types$TwoFactorAuthPayload$$anon$157 as $c_Lpresto_types$TwoFactorAuthPayload$$anon$157 };
$p = $c_Lpresto_types$TwoFactorAuthPayload$$anon$157.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthPayload$$anon$157;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthPayload$$anon$157() {
}
export { $h_Lpresto_types$TwoFactorAuthPayload$$anon$157 as $h_Lpresto_types$TwoFactorAuthPayload$$anon$157 };
$h_Lpresto_types$TwoFactorAuthPayload$$anon$157.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.ccJ;
});
$p.L = (function() {
  if ((!this.ccC)) {
    this.ccB = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.ccC = true;
  }
  return this.ccB;
});
$p.O = (function() {
  if ((!this.ccL)) {
    this.ccK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.ccL = true;
  }
  return this.ccK;
});
$p.E = (function() {
  return this.ccO;
});
$p.t = (function() {
  if ((!this.ccI)) {
    this.ccH = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("secret", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.ccI = true;
  }
  return this.ccH;
});
$p.M = (function() {
  if ((!this.ccE)) {
    this.ccD = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.ccE = true;
  }
  return this.ccD;
});
$p.Q = (function() {
  if ((!this.ccG)) {
    this.ccF = new $j_presto$002etypes$0024$0024anon$0024158.$c_Lpresto_types$$anon$158();
    this.ccG = true;
  }
  return this.ccF;
});
$p.w = (function() {
  if ((!this.ccN)) {
    this.ccM = false;
    this.ccN = true;
  }
  return this.ccM;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee175) => ((p) => \u03b4scrutinee175.cGB(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dSeed$002dPayload$0024.$m_Lpresto_types$TwoFactorAuthSeedPayload$())));
});
var $d_Lpresto_types$TwoFactorAuthPayload$$anon$157 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthPayload$$anon$157, "presto.types$TwoFactorAuthPayload$$anon$157", ({
  a2m: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$TwoFactorAuthPayload$$anon$157 as $d_Lpresto_types$TwoFactorAuthPayload$$anon$157 };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Payload$$anon$157.js.map
